import React from 'react';
import { StyledSelectionItem, StyledSelectionView } from './styles';
import { HALF_DAY_HOURS, parseNumberToString } from './utils';
var SelectionView = function (props) {
    var source = props.source, onClick = props.onClick, value = props.value, automationId = props.automationId, size = props.size, minProp = props.min, maxProp = props.max, isTwelveHourSystem = props.isTwelveHourSystem;
    var min = minProp !== undefined && isTwelveHourSystem
        ? minProp % HALF_DAY_HOURS
        : minProp;
    var max = maxProp !== undefined && isTwelveHourSystem
        ? maxProp % HALF_DAY_HOURS
        : maxProp;
    var handleClick = function (toValue, disabled) {
        if (disabled) {
            return undefined;
        }
        return function () { return onClick(toValue); };
    };
    var showValue = parseNumberToString(value, isTwelveHourSystem);
    return (React.createElement(StyledSelectionView, { size: size }, source.map(function (v) {
        var disabled = !!((max !== undefined && v > max) ||
            (min !== undefined && v < min));
        var itemShowValue = parseNumberToString(v, isTwelveHourSystem);
        return (React.createElement(StyledSelectionItem, { disabled: disabled, "data-focusable": true, radius: "round", wrapperSize: size, key: v, onClick: handleClick(v, disabled), selected: itemShowValue === showValue, "data-test-automation-id": automationId && automationId + "-" + itemShowValue, itemLength: source.length },
            React.createElement(React.Fragment, null, itemShowValue)));
    })));
};
SelectionView.displayName = 'SelectionView';
export { SelectionView };
